<template lang="pug">
  .component-client-action-buttons
    button.button.warning(type="button", v-on:click="remove") Delete
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper"

  export default {
    name: "VehicleCostButtons",
    components: {},
    data() {
      return {
        entity: null
      }
    },
    created() {
    },
    methods: {
      remove: function () {
        this.$confirm('Are you sure?', `Do you really want to <strong>Remove</strong> the <strong>VC${this.item.id} ${this.item.type.name}</strong> cost?`, () => {
          KeplerBackofficeSdk.assetCosts.select(this.item).remove(() => {
            MaggieHelper.notification('delete-esit', "Cost removed")
          })
        })
      },
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleCostButtons.vue?b595c0be